var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91093 18.8433C9.26647 17.9968 8.82972 16.9837 8.67667 15.8799H0C0.201442 19.3662 1.5915 22.5336 3.77104 24.9832L9.91093 18.8433Z",
    fill: "#DA9869"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67667 14.12C8.82972 13.0161 9.26647 12.003 9.91093 11.1566L3.77104 5.0166C1.5915 7.46614 0.201442 10.6337 0 14.12H8.67667Z",
    fill: "#AFAFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8799 0V8.71376C16.9711 8.87085 17.9726 9.30532 18.8108 9.94345L24.9832 3.77104C22.5337 1.5915 19.3662 0.201442 15.8799 0Z",
    fill: "#B4B2EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1606 9.91551C12.0078 9.28012 13.0191 8.85157 14.1195 8.70474V0C10.6332 0.201442 7.46565 1.5915 5.01611 3.77104L11.1606 9.91551Z",
    fill: "#85CB62"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2581 15.8799C21.1073 16.9677 20.6809 17.9674 20.0518 18.8063L26.2287 24.9832C28.4083 22.5337 29.7983 19.3662 29.9997 15.8799H21.2581Z",
    fill: "#62A3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0518 11.1935C20.6809 12.0325 21.1073 13.0321 21.2581 14.12H29.9997C29.7983 10.6337 28.4082 7.46614 26.2287 5.0166L20.0518 11.1935Z",
    fill: "#FF6871"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1195 21.2938C13.0191 21.147 12.0078 20.7184 11.1606 20.083L5.01611 26.2275C7.46571 28.407 10.6332 29.7971 14.1195 29.9985V21.2938Z",
    fill: "#7ED3D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8108 20.0566C17.9727 20.6948 16.9711 21.1292 15.8799 21.2863V30.0001C19.3662 29.7987 22.5337 28.4086 24.9832 26.2291L18.8108 20.0566Z",
    fill: "#E08CBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomIcon);
export default __webpack_public_path__ + "static/media/custom-icon.51302f9cc3fd0e2907a27473538069e3.svg";
export { ForwardRef as ReactComponent };